export const TagCache: string[] = ['Important', 'New', 'Out Of Stock', 'Ready'];
